import React from 'react';

const SvgOther49 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M15.41 14.41a2 2 0 0 1 .59 1.42V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.17a2 2 0 0 1 .59-1.42L4.2 12.8A7 7 0 0 0 5.51 11l.94-1.89A2 2 0 0 1 8.24 8h1.52a2 2 0 0 1 1.79 1.13l.94 1.87a7 7 0 0 0 1.31 1.8zM18 8v1a2 2 0 1 1-4 0V8a2 2 0 1 1 4 0zM2 11a2 2 0 0 1-2-2V8a2 2 0 1 1 4 0v1a2 2 0 0 1-2 2zm8-7V2a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0zM4 4V2a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgOther49 svgRef={ref} {...props} />);
export default ForwardRef;
